import { withFormik } from "formik";
import { LoginFormFields } from "./LoginFormFields";
import { withRouter } from "react-router";
import { errorMessageText } from "../../lib/constants";
import { sendCode } from "../../service/login-service";

export const LoginForm = withRouter(
  withFormik({
    enableReinitialize: true,
    mapPropsToValues: () => ({
      email: "",
      global_error: "",
    }),
    
    validate: values => {
      const errors = {};

      if (!values.email) {
        errors.email = errorMessageText.email;
      }

      return errors;
    },

    handleSubmit: async (
      values,
      { setSubmitting, setFieldError, props: { onShowModal } },
    ) => {
      setSubmitting(true);
      try {
        const response = await sendCode(values.email);
        setSubmitting(false);
        onShowModal(values.email, response.user_id);
      } catch (error) {
        setSubmitting(false);
        const message = error.response.data.error
        setFieldError("global_error", message);
      }

      return;
    },

    displayName: "LoginForm",
  })(LoginFormFields),
);
